module.exports = "<svg viewBox=\"0 0 501 266\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Final\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><polyline id=\"Path-2\" stroke=\"#000000\" stroke-width=\"2\" fill-rule=\"nonzero\" points=\"264.758825 0 264.758825 49.5754376 1 49.5754376 1 152.66756 499.669853 152.66756 499.669853 201.522312 263.361146 201.522312 263.361146 265.409319\"></polyline></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/About-Path.svg
// module id = lxqc
// module chunks = 11